import React from "react";
import { useAppContext } from "../../AppProvider";
import { useDeleteUserContext } from "./providers/Delete";
import ButtonUtility from "../../Components/Buttons/Utility";
import ButtonDelete from "../../Components/Buttons/Delete";
import { useIndexUsersContext } from "./providers/Index";

const Delete = () => {
  const { data, callback, deleteUsers, loader } = useDeleteUserContext();
  const { dictionary } = useAppContext();
  const indexUsersContext = useIndexUsersContext();
  const modalConfig = indexUsersContext?.modalConfig;

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <h3 className="text-center">
            {modalConfig?.title || dictionary.actions.delete}
          </h3>
          <label>
            {data?.length && data.length > 1
              ? dictionary.messages.ask_to_delete_selected
              : dictionary.messages.ask_to_delete}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (callback) {
              callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonDelete
          className="w-50"
          onClick={() => deleteUsers()}
          disabled={loader}
          loading={loader}
        >
          {dictionary.actions.delete}
        </ButtonDelete>
      </div>
    </React.Fragment>
  );
};
export default Delete;
